const REDIRECT_URL = '/api/oauth2/authorization/authentik';

export const authConstants = {
    REDIRECT_URL,
};
